import React from "react";
import cx from "classnames";
import s from "./loaderIcon.scss";

export default class LoaderIcon extends React.Component {
  render() {
    let { className, iconSize, color } = this.props;
    return (
      <div
        className={cx(className, s.wrapIconLoader)}
        style={{
          width: iconSize ? iconSize : "1rem",
          height: iconSize ? iconSize : "1rem",
        }}
      >
        <svg
          className={s.iconLoader}
          xmlns="http://www.w3.org/2000/svg"
          width={iconSize ? iconSize : "1rem"}
          height={iconSize ? iconSize : "1rem"}
          viewBox="0 0 64 64"
        >
          <rect
            fill={color ? color : "var(--accent)"}
            x="0"
            y="25"
            width="14"
            height="14"
            // rx="1"
            // ry="1"
          />
          <rect
            fill={color ? color : "var(--accent)"}
            x="16.67"
            y="25"
            width="14"
            height="14"
            // rx="1"
            // ry="1"
          />
          <rect
            fill={color ? color : "var(--accent)"}
            x="33.33"
            y="25"
            width="14"
            height="14"
            // rx="1"
            // ry="1"
          />
          <rect
            fill={color ? color : "var(--accent)"}
            x="50"
            y="25"
            width="14"
            height="14"
            // rx="1"
            // ry="1"
          />
        </svg>
      </div>
    );
  }
}
